module.exports = __webpack_public_path__ + "front/img/bg04.a4bcc42e.png";